import React from 'react';
import { Linkedin, Twitter, Instagram, Mail, ArrowUpRight } from 'lucide-react';
import Logo from './ui/Logo';
import { REAL_ESTATE_PATH, siteHref } from '../lib/router';

const linkGroups = [
    {
        title: 'Services',
        links: [
            { label: 'AI Agents & Assistants', href: '#services' },
            { label: 'Workflow Engineering', href: '#services' },
            { label: 'WhatsApp Automation', href: '#services' },
            { label: 'CRM Integrations', href: '#services' },
            { label: 'Real Estate', href: REAL_ESTATE_PATH },
        ],
    },
    {
        title: 'Company',
        links: [
            { label: 'Our Work', href: '#work' },
            { label: 'Process', href: '#process' },
            { label: 'About', href: '#team' },
            { label: 'FAQ', href: '#faq' },
        ],
    },
];

const socials = [
    { icon: Linkedin, href: 'https://www.linkedin.com/in/emmanuel-ada/', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'X / Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
];

const Footer: React.FC = () => {
    return (
        <footer className="relative bg-navy-950 border-t border-white/[0.06] pt-16 pb-8">
            <div className="container-x">
                <div className="grid md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr] gap-10 md:gap-12">
                    {/* Brand + CTA */}
                    <div>
                        <Logo />
                        <p className="mt-5 text-text-muted max-w-xs leading-relaxed">
                            Helping ambitious businesses scale through AI agents, intelligent workflows, and seamless integrations.
                        </p>
                        <a
                            href={siteHref('#contact')}
                            className="group mt-6 inline-flex items-center gap-2 text-brand-cyan font-semibold hover:gap-3 transition-all"
                        >
                            Start a project <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
                        </a>
                    </div>

                    {/* Link columns */}
                    {linkGroups.map((group) => (
                        <div key={group.title}>
                            <h4 className="text-white font-display font-bold mb-4">{group.title}</h4>
                            <ul className="space-y-2.5 text-sm">
                                {group.links.map((link) => (
                                    <li key={link.label}>
                                        <a href={siteHref(link.href)} className="text-text-muted hover:text-brand-cyan transition-colors">
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    {/* Connect */}
                    <div>
                        <h4 className="text-white font-display font-bold mb-4">Get in touch</h4>
                        <a href="mailto:info@automateit.ng" className="inline-flex items-center gap-2 text-text-muted hover:text-brand-cyan transition-colors mb-5">
                            <Mail className="w-4 h-4" />
                            info@automateit.ng
                        </a>
                        <div className="flex gap-3">
                            {socials.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target={s.href.startsWith('http') ? '_blank' : undefined}
                                    rel={s.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                                    className="w-10 h-10 rounded-xl bg-white/[0.05] border border-white/[0.08] grid place-items-center text-text-muted hover:text-white hover:border-brand-cyan/50 hover:bg-brand-cyan/10 transition-all"
                                    aria-label={s.label}
                                >
                                    <s.icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-text-faint">
                    <div>&copy; {new Date().getFullYear()} AutomateIT.ng. All rights reserved.</div>
                    <div className="flex gap-6">
                        <a href="#top" className="hover:text-white transition-colors">Privacy Policy</a>
                        <a href="#top" className="hover:text-white transition-colors">Terms of Service</a>
                        <a href="#top" className="hover:text-white transition-colors">Back to top ↑</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
